
import gsap from '@gsap/business';

export default class Tilt {

  constructor(node) {
    this.node = node;
    this.init();
    this.addListeners();
  }

  init() {
    this.media = this.node.querySelector('img');
    this.mouse = {x: 0, y: 0, eX: 0, eY: 0};
    this.height = Tilt.calculateHeight();
  }

  addListeners() {
    this.onMouseMove = this.mouseMoveHandler.bind(this);
    this.onResize = this.onResizeHandler.bind(this);
    this.onTick = this.tickHandler.bind(this);

    this.node.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('resize', this.onResize)
    gsap.ticker.add(this.onTick);
  }

  removeListeners() {
    this.node.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('resize', this.onResize)
    gsap.ticker.remove(this.onTick);
  }

  mouseMoveHandler(e) {
    this.mouse.y = (e.clientY / window.innerHeight);
  }

  onResizeHandler() {
    this.height = Tilt.calculateHeight();
  }

  tickHandler() {
    const value = window.innerHeight - this.height;
    this.mouse.eY += (this.mouse.y - this.mouse.eY) / 60;
    this.media.style.transform = `translateY(${value * this.mouse.eY}px)`;
  }

  static calculateHeight = (ratio) => {
    const aspectRatio = ratio || 1 / 2;
    return parseFloat((window.innerWidth / aspectRatio).toFixed(2));
  };
}
